<template>
    <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M1 3.875C1 3.392 1.449 3 2.003 3h15.994c.554 0 1.003.392 1.003.875v12.25c0 .483-.449.875-1.003.875H2.003C1.449 17 1 16.608 1 16.125V3.875Zm3.447 2.23a1 1 0 0 0-.894 1.79l6 3a1 1 0 0 0 .894 0l6-3a1 1 0 1 0-.894-1.79L10 8.883 4.447 6.106Z" />
    </svg>
</template>
